import { CloseIcon } from '@/assets/icons/close.icon';
import { cn } from '@/core/utils/cn';

type TabHeaderProps = {
  title: string;
  toggleDialog: () => void;
  className?: string;
};

const TabHeader = ({ title, toggleDialog, className }: TabHeaderProps) => {
  return (
    <div className={cn('flex justify-between items-center mb-5', className)}>
      <div className="text-xl text-light font-semibold">{title}</div>
      <div onClick={toggleDialog} className="cursor-pointer">
        <CloseIcon />
      </div>
    </div>
  );
};

export default TabHeader;
